import Box from '@mui/material/Box';
import React from 'react';

import { FlowStage } from './FlowStage';
import { LANE_LABEL_SX, LANE_TOKENS } from './ServiceFlowRail.styles';
import { ActivityLaneModel } from '../../../@types/service-activity.type';

export interface FlowLaneProps {
  lane: ActivityLaneModel;
  canDrillDown: boolean;
  onStageSelect: (statusGroup: string) => void;
  /** Lanes flex in proportion to their stage count so stages stay a
   *  consistent width across the whole rail. */
  flex: number;
}

export const FlowLane: React.FC<FlowLaneProps> = ({ lane, canDrillDown, onStageSelect, flex }) => {
  const tokens = LANE_TOKENS[lane.lane];

  return (
    <Box sx={{ flex, minWidth: 0, display: 'flex', flexDirection: 'column', gap: '4px' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px', px: '8px' }}>
        <Box component="span" sx={{ ...LANE_LABEL_SX, color: tokens.text }}>
          {lane.label}
        </Box>
        {/* Hairline runs to the end of the lane, tying its stages together. */}
        <Box aria-hidden sx={{ flex: 1, height: '1px', bgcolor: 'v4.border' }} />
        <Box
          component="span"
          sx={{
            fontSize: '10px',
            fontWeight: 600,
            fontVariantNumeric: 'tabular-nums',
            color: 'text.secondary',
          }}
        >
          {lane.total.toLocaleString()}
        </Box>
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'stretch' }}>
        {lane.stages.map((stage) => (
          <FlowStage
            key={stage.field}
            stage={stage}
            tokens={tokens}
            canDrillDown={canDrillDown}
            onSelect={onStageSelect}
          />
        ))}
      </Box>
    </Box>
  );
};
